import CheckedSvg from '../../../assets/images/checked.svg';
import SummarySvg from '../../../assets/images/summary.svg';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";


export const SummaryStep = () => {
    const { t } = useTranslation();
    let { domainId } = useParams();

    return (
        <nav aria-label="breadcrumb">
            <ol className="d-flex breadcrumb col-xl-12 mx-auto">    
                <li><a href="/#" className="disabled"><span className="circle"><img src={CheckedSvg} width="30px" alt='' /></span>1. {t('ProfileText')}</a></li>
                <li><a href="/#" className="disabled"><span className="circle"><img src={CheckedSvg} width="30px" alt='' /></span>2. {t('DocumentText')}</a></li>
                <li className="active"><a href="/#" className="disabled"><span className="circle"><img src={SummarySvg} width="30px" alt='' /></span>3. {t('SummaryText')}</a></li>
            </ol>
        </nav>

    )
}